import React from "react";
import { motion } from "framer-motion";

function AboutContent() {
  return (
    <motion.div
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 0.5, duration: 0.5 }}
      className="max-w-3xl mx-auto text-center pb-8"
    >
      <motion.p
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 1.1, duration: 0.5 }}
        className="mt-4 text-lg text-gray-500"
      >
        Hello, I am Sertaç Gültekin. I have been working in software development for over two years, and during this time, I have been involved in various projects.
        <br />
        <br /> When my passion for the software world combined with my desire to develop new and innovative solutions, I felt motivated to build a successful career in this field. Throughout this period, I had the opportunity to work with different programming languages and technologies and participate in various projects.
        <br />
        <br /> My main interest lies in web development and software engineering. I started with fundamental web technologies like HTML, CSS, and JavaScript, and later, I learned to work with frameworks and libraries. By working with front-end and back-end technologies, I develop user-friendly, functional, and secure web applications.
        <br />
        <br /> I also have experience in mobile app development. I have worked on application development projects for the React Native. I pay attention to user interface design, database integration, and data management to meet users' needs and provide an excellent user experience.
        <br />
        <br /> During the software development process, I maintain my belief in teamwork while also valuing taking responsibility and working independently. With my good communication and problem-solving skills, I collaborate effectively to ensure the successful completion of projects.
        <br />
        <br /> In this portfolio website, I will provide more details about my projects and work. I have some exciting examples to share, and I am eagerly looking forward to participating in new projects to enhance and expand my past experiences.
        <br />
        <br /> If you would like to collaborate, learn more about my projects, or if you have any questions, please feel free to contact me. I have included my contact information on my portfolio website.
        <br />
        <br /> Thank you and welcome!
      </motion.p>
    </motion.div>
  );
}

export default AboutContent;
